import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import { PrimaryLink } from "../ui/Buttons";
import CallButton from "../ui/CallButton";
import DirectionsButton from "../ui/DirectionsButton";
import BusinessHours from "../ui/BusinessHours";
import ReviewSection from "../ui/ReviewSection";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import AC from "../../assets/AC.jpg";

const AirConditioning = () => {
  return (
    <>
      <SeoHead
        title="Auto AC Repair & Service in Temecula | Advanced Automotive Smog"
        description="Air conditioning service in Temecula, including refrigerant service and leak checks, to keep your car's AC blowing cold when you need it most."
        path="/services/air-conditioning"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Air Conditioning Services"
          path="/services/air-conditioning"
          description="Air conditioning service in Temecula, including refrigerant service and leak checks."
          serviceType="Air conditioning service"
        />
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">
          
          {/* Image - prioritized for mobile */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={AC}
                alt="Auto air conditioning system"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text content */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Climate Control Service
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-navy-900 mb-3">
              Air Conditioning Services
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Don&apos;t let a weak AC turn every drive into a heat wave. We
              keep your air conditioning system blowing cold, clean air so
              you&apos;re comfortable no matter how hot it gets outside.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What is an AC Service?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              Over time, your A/C can lose refrigerant, develop leaks, or get
              clogged with moisture and debris. That means warmer air, bad
              smells, and extra strain on your engine.
              <br />
              <br />
              Our AC service includes a full system check, leak inspection,
              performance testing, and recharge if needed. We make sure your
              system cools quickly, runs efficiently, and keeps you comfortable
              all year long.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Complete A/C performance and pressure diagnostics</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Refrigerant recharge and leak checks</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>High-quality replacement parts and components</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Service for all makes and models</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Tips to keep your A/C colder for longer</span>
              </li>
            </ul>

            {/* Clean centered button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>

          </div>
        </div>

        <div className="mt-14 space-y-10 border-t border-slate-200 pt-12">
          <BusinessHours tone="light" />
          <ReviewSection tone="light" />
          <div className="flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:justify-center">
            <CallButton className="px-8 py-3 text-base" />
            <DirectionsButton className="px-8 py-3 text-base" />
          </div>
        </div>
    </ServicePageShell>
    </>
  );
};

export default AirConditioning;
